import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaHome, FaBuilding, FaTools, FaCouch, FaKey, FaDraftingCompass } from 'react-icons/fa';
import SEO from '../Components/SEO';
import './Services.css';

const services = [
  {
    icon: <FaHome />,
    title: "Residential Construction",
    desc: "Crafting bespoke luxury villas and modern homes in Madurai with attention to structural integrity and architectural details.",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=800&q=80",
  },
  {
    icon: <FaBuilding />,
    title: "Commercial Construction",
    desc: "Technical expertise in high-scale commercial projects, corporate office buildings, shopping complexes, and industrial sites.",
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=800&q=80",
  },
  {
    icon: <FaTools />,
    title: "Renovation & Remodeling",
    desc: "Upgrading structures with engineering reinforcements, space styling, and renewing layouts to fit modern demands.",
    image: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=800&q=80",
  },
  {
    icon: <FaCouch />,
    title: "Interior Works",
    desc: "Custom interior styling, modern false ceilings, space-saving modular kitchens, and high-end wardrobe carpentry.",
    image: "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?auto=format&fit=crop&w=800&q=80",
  },
  {
    icon: <FaKey />,
    title: "Turnkey Construction",
    desc: "End-to-end design & build packages managing architectural plans, permits, civil execution, and handover of final keys.",
    image: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?auto=format&fit=crop&w=800&q=80",
  },
  {
    icon: <FaDraftingCompass />,
    title: "Architecture & Planning",
    desc: "Professional floor plans, structural steel layouts, 3D exterior design elevations, and legal clearance layouts.",
    image: "https://images.unsplash.com/photo-1503387762-592dea58ef23?auto=format&fit=crop&w=800&q=80",
  }
];

const Services = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="services-page">
      <SEO 
        title="Our Services" 
        description="VARK Builders offers premier construction services in Madurai, including luxury villas, commercial projects, interior design, renovations, and turnkey construction."
      />

      <section className="services-banner">
        <div className="floating-elements">
          <motion.div 
            className="float-circle circle-1" 
            animate={{ y: [0, -30, 0], x: [0, 20, 0] }}
            transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
          />
          <motion.div 
            className="float-circle circle-2" 
            animate={{ y: [0, 30, 0], x: [0, -20, 0] }}
            transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
          />
          <motion.div 
            className="float-circle circle-3" 
            animate={{ scale: [1, 1.2, 1] }}
            transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
          />
        </div>

        <div className="container">
          <motion.div 
            className="banner-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
          >
            <span className="subtitle">What We Build</span>
            <h1>Premier Construction <span>Services</span></h1>
            <p>From luxury residential villas to modern commercial landmarks, we deliver excellence through engineering precision.</p>
          </motion.div>
        </div>
      </section>

      <section className="services-grid-section">
        <div className="container">
          <div className="services-list-grid">
            {services.map((item, index) => (
              <motion.div 
                className="service-feature-card" 
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: (index % 3) * 0.1, duration: 0.8 }}
              >
                <div className="service-img">
                  <img src={item.image} alt={item.title} loading="lazy" />
                  <div className="service-icon-box">{item.icon}</div>
                </div>
                <div className="service-info">
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="process-cta">
        <div className="container">
          <div className="cta-glass-card">
            <h2>Building Your Vision <span>Into Reality</span></h2>
            <p>Our team of expert civil engineers and architects are ready to handle your next project with dedicated professionalism.</p>
            <Link to="/contact" className="cta-btn-services font-oswald">Consult Our Experts</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
